import { Action, createReducer, on } from '@ngrx/store';
import { toggleEditMode, toggleSubmitFeedbackPopover } from './shared.actions';

export interface SharedState {
  isEditMode: boolean;
  isSubmitFeedbackOpend: boolean;
}

export const initialLogsState: SharedState = {
  isEditMode: false,
  isSubmitFeedbackOpend: false
};

export const uiReducer = createReducer(
  initialLogsState,
  on(toggleEditMode, (state, { mode }) => {
    return {
      ...state,
      isEditMode: mode
    };
  }),
  on(toggleSubmitFeedbackPopover, state => {
    return {
      ...state,
      isSubmitFeedbackOpend: !state.isSubmitFeedbackOpend
    };
  })
);

export const SHARED_FEATURE_KEY = 'shared';
export function sharedReducer(state: SharedState | undefined, action: Action) {
  return uiReducer(state, action);
}
